"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tracker = void 0;
const tslib_1 = require("tslib");
const Guard_1 = require("../logic/Guard");
const ValueObject_1 = require("./ValueObject");
const EAppType_1 = require("./EAppType");
const Tracker_validator_1 = tslib_1.__importDefault(require("./Tracker.validator"));
const firebaseTypes_1 = require("../infra/firebaseTypes");
class Tracker extends ValueObject_1.ValueObject {
    constructor(value) {
        super(value);
    }
    static validate(raw, ref) {
        try {
            Tracker_validator_1.default(raw);
            return Guard_1.Guard.pass();
        }
        catch (e) {
            ValueObject_1.ValueObject.handleValidationError(e, ref);
            return Guard_1.Guard.fail(e.message);
        }
    }
    static create(p) {
        return new Tracker(p);
    }
    static newDTOFromWeb(userId, key) {
        return {
            key: key || null,
            createdAt: firebaseTypes_1.FB_SV_TIMESTAMP,
            updatedAt: firebaseTypes_1.FB_SV_TIMESTAMP,
            createdBy: userId,
            updatedBy: userId,
            createdApp: EAppType_1.EAppType.V.WEB,
            updatedApp: EAppType_1.EAppType.V.WEB,
        };
    }
    static newDTOFromCF(userId, appType, key) {
        return {
            key: key || null,
            createdAt: firebaseTypes_1.FB_SV_TIMESTAMP,
            updatedAt: firebaseTypes_1.FB_SV_TIMESTAMP,
            createdBy: userId,
            updatedBy: userId,
            createdApp: appType,
            updatedApp: appType,
        };
    }
    static newDTOFromCFLocalTime(userId, appType, key) {
        return {
            key: key || null,
            createdAt: Date.now(),
            updatedAt: Date.now(),
            createdBy: userId,
            updatedBy: userId,
            createdApp: appType,
            updatedApp: appType,
        };
    }
    static newDTOFromScheduled() {
        return {
            key: null,
            createdAt: firebaseTypes_1.FB_SV_TIMESTAMP,
            updatedAt: firebaseTypes_1.FB_SV_TIMESTAMP,
            createdBy: "schedule",
            updatedBy: "schedule",
            createdApp: EAppType_1.EAppType.V.SERVICE_CORE,
            updatedApp: EAppType_1.EAppType.V.SERVICE_CORE,
        };
    }
    get createdAt() {
        return this.value.createdAt;
    }
    get updatedAt() {
        return this.value.updatedAt;
    }
    get createdBy() {
        return this.value.createdBy;
    }
    get updatedBy() {
        return this.value.updatedBy;
    }
    get createdApp() {
        return this.value.createdApp;
    }
    get updatedApp() {
        return this.value.updatedApp;
    }
    get previousValue() {
        return this.value.previousValue;
    }
    get comment() {
        return this.value.comment || "";
    }
    get key() {
        return this.value.key;
    }
}
exports.Tracker = Tracker;
Tracker.persist = {
    clientTimestampOnCreate: ["createdAt"],
    clientTimestampOnUpdate: ["updatedAt"],
    currentUserIdOnCreate: ["createdBy"],
    currentUserIdOnUpdate: ["updatedBy"],
    currentAppTypeOnCreate: ["createdApp"],
    currentAppTypeOnUpdate: ["updatedApp"],
};
//# sourceMappingURL=Tracker.js.map